export const environment = {
  baseUrl: 'https://dev.review.manop.gateway.nghis-dev.com/',
  adminHospitalCode: '0000000018',
  apiUrl: 'https://eut0p5boz7.execute-api.ap-northeast-1.amazonaws.com/dev/',
  applicationName: 'manop',
  cgwAuthWebUrl: 'https://cgw-auth-web.gateway.nghis-dev.com/',
  tokenEndPoint:
    'https://nd-t4mxr6ga-{hospitalCode}.auth.ap-northeast-1.amazoncognito.com/oauth2/token',
  facadeSettings: {
    apiUrl: 'https://vma810ppg0.execute-api.ap-northeast-1.amazonaws.com/dev/',
    apiKey: 'AGNhQ0ZHKt1ryEKbuZVNm88tqdtpFdsu4RLXdl7T',
  },
};
